// Main entry — the ProgramPolicies View. It owns the editor open/close UI
// state; the attached policies + values + their mutators come in as props
// from ProgramDetail (they feed the BuilderConfig). Sim wrappers live under
// ./sim and are never imported here.
export { ProgramPolicies } from "./ProgramPolicies";
export type { ProgramPoliciesProps } from "./ProgramPolicies";
